module.exports = __webpack_public_path__ + "static/images/bp-s-logo.25d9737.png";